import React, { useState } from 'react';
import styles from './transactionDetailsNameSection.module.scss';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import Selectors from 'src/utils/selectors';
import { IconEdit } from '@americanexpress/dls-react';
import { DLSSize } from 'src/types/dls-size.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import IconButton from 'src/components/icon-button/IconButton';
import { ButtonType } from 'src/types/button-type.enum';
import NicknameEditBox from 'src/components/nickname-edit-box/NicknameEditBox';
import { useTransaction, useUpdateTransaction } from 'src/hooks/queries/transactions';
import { useParams, useLocation } from 'react-router-dom';

const TransactionDetailsNameSection = (): JSX.Element => {
    const location = useLocation();
    const params = useParams();

    const { isLoading: isLoadingTransaction, data: transaction } = useTransaction(Number(params.id));
    const { mutateAsync: updateTransaction } = useUpdateTransaction();

    const [isEditingName, setIsEditingName] = useState<boolean>(false);

    // Loading state handled in parent
    if (isLoadingTransaction) return null;

    return (
        <>
            <div className={styles.detailsSection}>
                <div className={styles.transactionNameContainer}>
                    <Typography
                        variant={TypographyVariants.HEADING_S}
                        className={styles.colorTextStrong}
                        component="h2"
                        data-cy={Selectors.Transactions.NAME}
                    >
                        {transaction?.displayName}
                    </Typography>
                    <IconButton
                        variant={ButtonType.TERTIARY}
                        className={styles.editNicknameButton}
                        onClick={() => {
                            setIsEditingName(!isEditingName);
                            trackClick(location.pathname, adobeTags.Transactions.Details.EditName);
                        }}
                        icon={<IconEdit size={DLSSize.SMALL} />}
                        title={LiteralsService.getLiteral('TransactionDetails.editName')}
                        data-cy={Selectors.SpendSmart.NAME_EDIT_BUTTON}
                        aria-expanded={isEditingName}
                    />
                </div>
            </div>
            {isEditingName && (
                <NicknameEditBox
                    className={styles.editNicknameBox}
                    label={LiteralsService.getLiteral('TransactionDetails.editName')}
                    nickname={transaction?.displayName}
                    handleSave={async (values) => {
                        await updateTransaction({ ...transaction, nickName: values.name });
                        setIsEditingName(false);
                        trackClick(location.pathname, adobeTags.Transactions.Details.SaveName);
                    }}
                    handleSecondaryButtonClick={() => {
                        setIsEditingName(false);
                        trackClick(location.pathname, adobeTags.Transactions.Details.CancelName);
                    }}
                    secondaryButtonLabel={LiteralsService.getLiteral('CommonText.cancel')}
                />
            )}
        </>
    );
};

export default TransactionDetailsNameSection;
